import { bunja } from 'bunja';
import { differenceInHours } from 'date-fns';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getUserLossProtectionApi } from '@flipster/apis/v1/user';
import { authBunja } from '@flipster/features/src/shared/auth/state';
import { convertDate } from '@flipster/utils/datetime';

export const lossProtectionBunja = bunja(() => {
  const { isCookieLoggedInAtom, userAtom } = bunja.use(authBunja);
  // kyc 활성화 후 3일 이내에 노출
  const isLossProtectedPeriodAtom = atom((get) => {
    const user = get(userAtom);
    const now = Date.now();
    const kycActivatedAt = convertDate(user?.kycActivatedAt) || 0;
    return differenceInHours(now, kycActivatedAt) < 24 * 3;
  });

  const getLossProtectionAtom = atomWithQuery((get) => {
    const isCookieLoggedIn = get(isCookieLoggedInAtom);
    const isLossProtectedPeriod = get(isLossProtectedPeriodAtom);

    return {
      queryKey: ['getUserLossProtectionApi', isCookieLoggedIn],
      queryFn: getUserLossProtectionApi,
      enabled: isCookieLoggedIn && isLossProtectedPeriod,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    };
  });

  const lossProtectionAtom = atom((get) => {
    const { data } = get(getLossProtectionAtom);
    return data?.data.lossProtection;
  });

  // 노출 조건: kyc 활성화 후 3일 이내에 노출, 노출 조건 만족 시 isEligible 이 true 인 경우 노출
  const isLossProtectedAtom = atom((get) => {
    const isLossProtectedPeriod = get(isLossProtectedPeriodAtom);
    const lossProtection = get(lossProtectionAtom);
    return isLossProtectedPeriod && Boolean(lossProtection?.isEligible);
  });

  return { isLossProtectedAtom, lossProtectionAtom };
});
lossProtectionBunja.debugLabel = 'lossProtectionBunja';
